import React, { useEffect, useState } from "react";
import { useUnitLelangData } from "../../hooks/useStaleWhileRevalidate";
import { Col, Container, Form, Modal, Row } from "react-bootstrap";
import CardUnit from "../../components/CardUnit/CardUnit";
import FilterUnitLelang from "../../components/Filters/FilterUnitLelang";
import FilterTag from "../../components/Filters/FilterTag";
import withoutAuth from "../../services/withoutAuthProvider";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import { format } from "date-fns";
import { defaultBanner } from "../../utils/defaultValue";
import { SkeletonUnitLelang } from "../../components/Skeleton/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import { actionsPage, pageSelector } from "../../redux/page.slice";
import ReactPaginate from "react-paginate";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
// import NumberFormat from "react-number-format";
import * as Yup from "yup";
import InfiniteScroll from "react-infinite-scroll-component";
import bg from "../../assets/images/bg-gradient.png";
// import moment from "moment";
import { subdomainSelector } from "../../redux/subdomain.slice";
import { formatDateTimeRange } from "../../helpers/dateRangeFormatter";

const initialPaginate = {
  search: "",
  page: 1,
  total: 0,
  page_size: 30,
};

const toastError = (message) => {
  return toast.error(message, {
    id: "error-message",
    duration: 3000,
  });
};

export default function UnitLelang() {
  const pageNumber = useSelector(pageSelector);
  const dispatch = useDispatch();
  const subdomain = useSelector(subdomainSelector);
  const today = format(new Date(), "yyyy");
  const { push, location } = useHistory();
  const dataPrev = location?.state?.dataFilter;

  // Track first render to prevent double API call when coming from navigation
  const isFirstRender = React.useRef(true);

  const [paginate, setPaginate] = useState({ ...initialPaginate });
  const [showRisalah, setShowRisalah] = useState(false);
  const [isRisalah, setRisalah] = useState(0);

  const [pageSelected, setPageSelected] = useState(pageNumber);
  const [jumptoPage, setJumptoPage] = useState();

  const { search: searchParams } = useLocation();
  const parameters = new URLSearchParams(searchParams);
  const auction_id = parameters.get("auction_id");

  // const newPage = event.selected;
  // dispatch(actionsPage.setPage({ page: newPage }));
  // setPageSelected(newPage);
  const handlePageClick = (event) => {
    dispatch(actionsPage.setPage({ page: event.selected }));
    setPageSelected(event.selected);

    // Update nilai input
    setValue("page", event.selected + 1);
    setJumptoPage(event.selected + 1);

    window.scrollTo({ top: 0 });
  };
  // const handlePageClick = (event) => {
  //   dispatch(actionsPage.setPage({ page: event.selected }));
  //   setPageSelected(event.selected);
  //   window.scrollTo({ top: 0 });

  const years = [
    {
      id: 1,
      name: `${today - 3} - ${today}`,
    },
    {
      id: 2,
      name: `${today - 7} - ${today - 4}`,
    },
    {
      id: 3,
      name: `${today - 11} - ${today - 8}`,
    },
    {
      id: 4,
      name: `${today - 15} - ${today - 12}`,
    },
    {
      id: 5,
      name: `Dibawah ${today - 16}`,
    },
  ];
  const silinders = [
    {
      id: 1,
      name: "Kurang dari 1000 cc",
    },
    {
      id: 2,
      name: "1001 cc - 1300 cc",
    },
    {
      id: 3,
      name: "1301 cc - 1600 cc",
    },
    {
      id: 4,
      name: "1601 cc - 2000 cc",
    },
    {
      id: 5,
      name: "Lebih dari 2000 cc",
    },
  ];

  // filtering state - Memoize to prevent unnecessary re-renders
  const initialFilterValue = React.useMemo(
    () => ({
      unit_maker_id: dataPrev?.unit_maker_id || "",
      unit_model_id: dataPrev?.unit_model_id || "",
      unit_model_type_id: dataPrev?.unit_model_type_id || "",
      unit_type_id: dataPrev?.unit_type_id || "",
      year: dataPrev?.year || "",
      location_id: dataPrev?.location_id || "",
      unit_segment_id: dataPrev?.unit_segment_id || "",
      year_start: "",
      year_end: "",
      engine_capacity_start: "",
      engine_capacity_end: "",
      auction_id: auction_id || dataPrev?.auction_id || "",
      grade: dataPrev?.grade || "",
      start_auction_date: dataPrev?.start_auction_date || "",
      sort_order: dataPrev?.sort_order || "",
      tag_id: dataPrev?.tag_id || "",
      start_base_price: dataPrev?.start_base_price || "",
      end_base_price: dataPrev?.end_base_price || "",
    }),
    [dataPrev, auction_id]
  );
  const [search, setSearch] = useState(dataPrev?.search || "");
  const [filterValue, setFilterValue] = useState(initialFilterValue);
  const [filterTag, setFilterTag] = useState([]);

  const validationSchema = Yup.object().shape({
    page: Yup.number(),
  });

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      page: pageSelected + 1,
    },
    resolver: yupResolver(validationSchema),
  });

  const resetFilter = () => {
    setFilterTag([]);
    setFilterValue({
      search: "",
      unit_maker_id: "",
      unit_model_id: "",
      unit_model_type_id: "",
      unit_type_id: "",
      year: "",
      location_id: "",
      unit_segment_id: "",
      auction_id: "",
      year_start: "",
      year_end: "",
      engine_capacity_start: "",
      engine_capacity_end: "",
      grade: "",
      start_auction_date: "",
      sort_order: "",
      tag_id: "",
      start_base_price: "",
      end_base_price: "",
    });
    setSearch("");
  };

  const removeTag = (idx) => {
    const foundData = filterTag.find((a, b) => b === idx);
    const name = foundData.name;
    setFilterValue((prev) => ({
      ...prev,
      [name]: "",
    }));
    setFilterTag((prev) => prev.filter((el) => el.name !== name));
  };

  // const nextPage = () => {
  //   const current = pageNumber;
  //   if (!(current + 1 > paginate.total)) {
  //     dispatch(actionsPage.resetPage());
  //     setPaginate((prev) => ({
  //       ...prev,
  //       page: prev.page + 1,
  //     }));
  //   }
  // };

  // const prevPage = () => {
  //   const current = pageNumber;
  //   const val = current - 1;
  //   if (!(val < 0) && val !== 0) {
  //     // console.log('prevv')
  //     dispatch(actionsPage.setPage({ page: val }));
  //     setPaginate((prev) => ({
  //       ...prev,
  //       page: val,
  //     }));
  //   }
  // };

  const generateYear = (id) => {
    let final = {};
    if (id !== "") {
      const foundYear = years.find((a) => a.id === parseInt(id));
      const this_year = foundYear?.name?.split(" ");
      if (foundYear.id === 5) {
        final.year_end = this_year[1];
      } else {
        final.year_start = this_year[0];
        final.year_end = this_year[2];
      }
    }
    return final;
  };

  const generateSilinder = (id) => {
    const foundCC = silinders.find((a) => a.id === parseInt(id));
    let final = {};
    if (foundCC) {
      const this_cc = foundCC.name.split(" ");
      if (foundCC.id === 5 || foundCC.id === 1) {
        final.engine_capacity_start = this_cc[2];
      } else {
        final.engine_capacity_start = this_cc[0];
        final.engine_capacity_end = this_cc[3];
      }
      return final;
    }
  };

  // Cache 15 menit untuk banners
  const { data: banners = [] } = useUnitLelangData(
    ["banners"],
    async () => {
      const params = {
        page: 1,
        page_size: 20,
        type: "UNIT_LELANG",
      };
      try {
        const response = await withoutAuth.getDataWithoutAuth("/api/banner", params);
        if (response?.status === 200) {
          const dat = response.data.data.data;
          if (dat?.length > 0) {
            return dat.map((b) => ({
              image_url: b.file_url ?? defaultBanner,
              link: b.link ?? "/",
            }));
          }
        }
      } catch (error) {
        console.error(error);
      }
      return [{ image_url: defaultBanner, link: "/" }];
    },
    {
      initialData: [{ image_url: defaultBanner, link: "/" }],
    }
  );

  // Cache 15 menit untuk unit types - sesuai Cache Duration.md
  const { data: unitType = [] } = useUnitLelangData(["unitType"], async () => {
    const response = await withoutAuth.getDataWithoutAuth("/api/unit-type", {});
    if (response?.status === 200) {
      return response?.data.data.data;
    }
    return [];
  });

  const processParams = () => {
    const params = {};
    // Process filterValue
    Object.keys(filterValue).forEach((key) => {
      if (filterValue[key] !== "") {
        if (key === "year") {
          const final = generateYear(filterValue[key]);
          Object.assign(params, final);
        } else if (key === "engine_capacity") {
          const final = generateSilinder(filterValue[key]);
          Object.assign(params, final);
        } else {
          params[key] = filterValue[key];
        }
      }
    });

    // Process other params
    params.page = pageSelected + 1;
    params.page_size = paginate.page_size;

    if (auction_id) params.auction_id = auction_id;

    // Overwrite unit_type_id if in filterValue
    if (filterValue.unit_type_id !== "") params.unit_type_id = filterValue.unit_type_id;

    // Ensure dataPrev logic if needed, but current implementation seems to just merge filterValue
    // lines 498-503 in original just re-merged filterValue which is already done above.

    if (subdomain !== "global") {
      params.exclusive_seller_slug = subdomain;
    }

    return params;
  };

  // Memoize query key to prevent unnecessary refetches due to object reference changes
  const queryKey = React.useMemo(
    () => ["unitLelang", filterValue, pageSelected, paginate.page_size, subdomain, auction_id],
    [filterValue, pageSelected, paginate.page_size, subdomain, auction_id]
  );

  // Cache 15 menit untuk unit list - sesuai Cache Duration.md
  const { data: queryData, isLoading: loading } = useUnitLelangData(
    queryKey,
    async () => {
      console.log("🔥 API CALL - /api/unit", {
        filterValue,
        pageSelected,
        page_size: paginate.page_size,
        subdomain,
        auction_id,
      });
      const params = processParams();
      const response = await withoutAuth.getDataWithoutAuth("/api/unit", params);

      if (response?.status === 200) {
        return response.data.data;
      }
      throw new Error(response?.data?.message || "Failed to fetch units");
    },
    {
      keepPreviousData: true,
      onSuccess: (dat) => {
        console.log("✅ API SUCCESS - /api/unit", dat);
        // Tampilkan risalah jika ada risalah_file_url dan ada auction_id
        if (dat?.data?.length > 0 && filterValue.auction_id) {
          const hasRisalah = dat?.data[0]?.auction?.risalah_file_url ? 1 : 0;
          setRisalah(hasRisalah);
        } else {
          setRisalah(0);
        }

        setPaginate((prev) => ({
          ...prev,
          page: dat.current_page + 1,
          total: dat.last_page,
          current_page: dat.current_page,
        }));
        // Sync redux page if needed, avoiding loop
        // dispatch(actionsPage.setPage({ page: dat?.current_page - 1 }));
      },
      onError: (err) => {
        console.error("❌ API ERROR - /api/unit", err);
        toastError(err.message);
      },
    }
  );

  const data = queryData?.data || [];

  const convertQueryParams = React.useCallback(() => {
    console.log("📝 convertQueryParams called", {
      locationSearch: location?.search,
      locationState: location?.state,
    });

    if (location?.search !== "") {
      const searchParams = {};
      const queryParams = new URLSearchParams(location.search);
      for (const [key, value] of queryParams) {
        if (key !== "page_size" && value !== "null") {
          searchParams[key] = value;
        }
      }

      console.log("🔍 Setting filterValue from URL params", searchParams);
      setFilterValue((data) => {
        // Only update if values actually changed
        const hasChanges = Object.keys(searchParams).some((key) => searchParams[key] !== data[key]);
        if (!hasChanges) {
          console.log("⏭️ SKIP filterValue update - No changes detected");
          return data;
        }
        console.log("✅ UPDATE filterValue from URL params");
        return {
          ...data,
          ...searchParams,
        };
      });
      if (searchParams.search) {
        setSearch((prev) => {
          if (prev === searchParams.search) return prev;
          return searchParams.search;
        });
      }
    } else {
      // Logic Reset / Apply State
      const stateData = location?.state?.dataFilter;
      if (stateData) {
        console.log("📦 Setting filterValue from state", stateData);
        setFilterValue((prev) => {
          // Check if values actually changed
          const newValues = {
            ...prev,
            unit_maker_id: stateData?.unit_maker_id || "",
            unit_model_id: stateData?.unit_model_id || "",
            unit_model_type_id: stateData?.unit_model_type_id || "",
            unit_type_id: stateData?.unit_type_id || "",
            year: stateData?.year || "",
            location_id: stateData?.location_id || "",
            unit_segment_id: stateData?.unit_segment_id || "",
            year_start: "",
            year_end: "",
            engine_capacity_start: "",
            engine_capacity_end: "",
            auction_id: stateData?.auction_id || "",
            grade: stateData?.grade || "",
            start_auction_date: stateData?.start_auction_date || "",
            sort_order: stateData?.sort_order || "",
            tag_id: stateData?.tag_id || "",
            start_base_price: stateData?.start_base_price || "",
            end_base_price: stateData?.end_base_price || "",
            search: stateData?.search || "",
          };

          // Compare if anything changed
          const hasChanges = Object.keys(newValues).some((key) => newValues[key] !== prev[key]);
          if (!hasChanges) {
            console.log("⏭️ SKIP filterValue update - No changes detected");
            return prev;
          }
          console.log("✅ UPDATE filterValue from state");
          return newValues;
        });

        if (stateData?.search) {
          setSearch((prev) => {
            if (prev === stateData.search) return prev;
            return stateData.search;
          });
        } else {
          setSearch((prev) => {
            if (prev === "") return prev;
            return "";
          });
        }
      } else {
        // Full Reset (Header Click)
        console.log("🔄 Full reset filterValue");
        setFilterValue((prev) => {
          const resetValues = {
            search: "",
            unit_maker_id: "",
            unit_model_id: "",
            unit_model_type_id: "",
            unit_type_id: "",
            year: "",
            location_id: "",
            unit_segment_id: "",
            auction_id: "",
            year_start: "",
            year_end: "",
            engine_capacity_start: "",
            engine_capacity_end: "",
            grade: "",
            start_auction_date: "",
            sort_order: "",
            tag_id: "",
            start_base_price: "",
            end_base_price: "",
          };

          // Check if already reset
          const hasChanges = Object.keys(resetValues).some((key) => resetValues[key] !== prev[key]);
          if (!hasChanges) {
            console.log("⏭️ SKIP filterValue reset - Already reset");
            return prev;
          }
          console.log("✅ RESET filterValue");
          return resetValues;
        });
        setSearch((prev) => {
          if (prev === "") return prev;
          return "";
        });
        setFilterTag([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.search, location?.state?.dataFilter]);

  // UseEffect for syncing external changes (like URL) to filterValue
  useEffect(() => {
    console.log("🔄 useEffect - convertQueryParams", {
      isFirstRender: isFirstRender.current,
      dataPrev,
      locationSearch: location?.search,
      locationState: location?.state,
    });

    // ALWAYS skip convertQueryParams on first render
    // filterValue is already initialized from initialFilterValue (which includes dataPrev)
    if (isFirstRender.current) {
      console.log("⏭️ SKIP convertQueryParams - First render");
      isFirstRender.current = false;
      return;
    }

    // Only run convertQueryParams on subsequent renders (URL changes, etc)
    console.log("▶️ RUN convertQueryParams");
    convertQueryParams();
  }, [convertQueryParams]);

  // Sync page input value when pageSelected changes
  useEffect(() => {
    setValue("page", pageSelected + 1);
    setJumptoPage(pageSelected + 1);
  }, [pageSelected, setValue]);

  // Handle search action
  const handleSearch = (id, tagId = null) => {
    setFilterValue((prev) => ({
      ...prev,
      search: search,
      unit_type_id: id,
      tag_id: tagId,
    }));
    setValue("page", 1);
    setPageSelected(0);
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();
    setPageSelected(Number(jumptoPage - 1));
  };

  // console.log("filter", filterValue);
  // console.log("dataPrv", dataPrev?.unit_type_id);
  return (
    <div>
      <FilterUnitLelang
        years={years}
        silinders={silinders}
        search={search}
        setSearch={setSearch}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        filterTag={filterTag}
        setFilterTag={setFilterTag}
        handleSearch={handleSearch}
        removeTag={removeTag}
        unitType={unitType}
        showTags={!filterValue.auction_id}
      />
      <FilterTag></FilterTag>
      <Container>
        <div className="d-flex justify-content-end"></div>
        {filterTag?.length !== 0 ? (
          <Row>
            <Col span={12}>
              <div className="tag-filter-unit">
                <div
                  className="d-inline cursor-pointer"
                  onClick={resetFilter}
                  style={{
                    textDecoration: "none",
                    fontWeight: "bold",
                    padding: "8px",
                  }}
                >
                  <span>Reset</span>
                </div>
                {filterTag.map((filter, idx) => (
                  <span className="tag" key={`filter ${idx}`}>
                    {filter?.label}
                    <span className="cursor-pointer" onClick={() => removeTag(idx)}>
                      <svg
                        style={{ marginLeft: "8px" }}
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.99999 4.05734L8.29999 0.757339L9.24266 1.70001L5.94266 5.00001L9.24266 8.30001L8.29999 9.24267L4.99999 5.94267L1.69999 9.24267L0.757324 8.30001L4.05732 5.00001L0.757324 1.70001L1.69999 0.757339L4.99999 4.05734Z"
                          fill="#9AA2B1"
                        />
                      </svg>
                    </span>
                  </span>
                ))}
              </div>
            </Col>
          </Row>
        ) : (
          ""
        )}
        <InfiniteScroll
          dataLength={data?.length}
          next={() => {}}
          //hasMore={dataPrev?.isTimeBid && paginate.current_page < paginate.total}
          hasMore={false}
          loader={<p>Loading...</p>}
          className="row mt-3 unit-lelang-grid"
          style={{ overflow: "hidden" }}
        >
          {loading ? (
            new Array(8).fill(1).map((el, indx) => (
              <div className="col-6 col-md-3 mb-4" key={`unit-${indx}`}>
                <SkeletonUnitLelang />
              </div>
            ))
          ) : data?.length > 0 ? (
            <>
              {data.map((item, idx) => {
                const visibleInfos = (item?.unit_informations || []).filter(info => info.is_visible !== 0);
                const year = visibleInfos.find((unit_information) => unit_information.label === "Tahun");

                const odometer = visibleInfos.find(
                  (unit_information) => unit_information.label === "Odometer"
                );

                const transmisi = visibleInfos.find(
                  (unit_information) => unit_information.label === "Transmisi"
                );

                const fuel = visibleInfos.find(
                  (unit_information) => unit_information.label === "Bahan Bakar"
                );

                const validityPeriod = item?.unit_documents?.find((unit_document) => unit_document.label === "STNK");

                const unitDetail = {
                  police_number: item?.police_number,
                  year: year?.value,
                  odometer: odometer?.value,
                  transmisi: transmisi?.value,
                  fuel: fuel?.value,
                  validityPeriod: validityPeriod?.additional_value,
                };

                const bannerStart = 2 - isRisalah;
                const normalizedIdx = idx - bannerStart;
                const cycle = normalizedIdx % 10;
                const isBannerSlot = normalizedIdx >= 0 && (cycle === 0 || cycle === 4);
                const bannerSlotIndex = isBannerSlot
                  ? Math.floor(normalizedIdx / 10) * 2 + (cycle === 4 ? 1 : 0)
                  : 0;
                const currentBanner = banners[bannerSlotIndex % banners.length];

                return (
                  <React.Fragment key={`unit-fragment-${idx}`}>
                    {isRisalah === 1 && idx === 0 && (
                      <div className="col-6 col-md-3 mb-4">
                        <div
                          className="card-unit h-100 cursor-pointer justify-content-center d-flex flex-column align-items-center pt-5"
                          style={{ backgroundImage: `url(${bg})` }}
                          onClick={() => setShowRisalah(true)}
                        >
                          <div className="mb-2 mt-5">
                            <span className="h1 text-white fw-bold">RISALAH</span>
                          </div>
                          <div className="bg-white px-2 py-1 rounded mb-5">
                            <span className="text-primary h-5">{data[0]?.unit_type?.name}</span>
                          </div>
                          <div className="mt-5">
                            <span className="text-white fw-bold fs-5">{data[0]?.auction?.location_name}</span>
                          </div>
                          <div className="mt-1 d-flex">
                            <div>
                              <span className="text-white">
                                {formatDateTimeRange(
                                  data[0]?.auction?.date_start,
                                  data[0]?.auction?.time_start,
                                  data[0]?.auction?.date_finish,
                                  data[0]?.auction?.time_finish
                                )}
                              </span>
                              {/* <span className="text-white">{moment(data[0]?.auction?.date_start).format("DD MMM YYYY")}</span>
                              <span className="text-white mx-1">&#x2022;</span>
                              <span className="text-white">{moment(data[0]?.auction?.time_start, "HH:mm:ss").format("HH:mm")}</span>
                              <span className="text-white">-</span>
                              <span className="text-white">{moment(data[0]?.auction?.time_finish, "HH:mm:ss").format("HH:mm")}</span> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="col-6 col-md-3 mb-4">
                      <CardUnit
                        link={
                          item?.auction?.is_exclusive && subdomain === "global"
                            ? "https://" +
                              item?.auction?.exclusive_seller_slug +
                              "." +
                              window.location.hostname +
                              "/unit-lelang/" +
                              item.id
                            : "/unit-lelang/" + item.id
                        }
                        lot_number={
                          item?.lot_number && item?.auction?.auction_lane_name
                            ? item?.auction?.auction_lane_name + item?.lot_number
                            : "-"
                        }
                        price={item?.base_price}
                        tags={[]}
                        nama={
                          item?.unit_name || item?.year + " " + item?.unit_maker?.name + " " + item?.unit_model?.name
                        }
                        location={item?.auction?.location_name}
                        auction={item?.auction}
                        pictures={item?.pictures}
                        onClick={() =>
                          item?.auction?.is_exclusive && subdomain === "global"
                            ? window.open(
                                "https://" +
                                  item?.auction?.exclusive_seller_slug +
                                  "." +
                                  window.location.hostname +
                                  "/unit-lelang/" +
                                  item.id
                              )
                            : push("/unit-lelang/" + item.id)
                        }
                        grade={item?.unit_inspection?.grade}
                        specialNIPL={item.number_of_nipl}
                        ppn_buyer_fee={item.ppn_buyer}
                        ppn_include={item.ppn_buyer_include}
                        unitType={item?.unit_type?.name}
                        unitDetail={unitDetail}
                        is_cancel_auction={item?.is_cancel_auction !== "0"}
                      />
                    </div>
                    {/* ini untuk web view */}
                    {isBannerSlot && (
                      <div className="d-none d-md-block col-6 col-md-3 mb-4">
                        <div
                          className="card-unit h-100 overflow-hidden cursor-pointer"
                          onClick={() => window.open(currentBanner?.link, "_blank")}
                          style={{ position: "relative", minHeight: "215px" }}
                        >
                          {/* Background — banner image bersih, cover penuh */}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundImage: `url(${currentBanner?.image_url})`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                            }}
                          />
                          {/* Frosted glass overlay di atas background */}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backdropFilter: "blur(15px)",
                              WebkitBackdropFilter: "blur(15px)",
                              backgroundColor: "rgba(0, 0, 0, 0.15)",
                            }}
                          />
                          {/* Foreground — banner image bersih, centered dengan contain */}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              alt="banner"
                              src={currentBanner?.image_url}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* ini untuk mobile view */}
                    {isBannerSlot && (
                      <div className="d-block d-md-none col-6 col-md-3 mb-4">
                        <div
                          className="card-unit h-100 overflow-hidden cursor-pointer"
                          onClick={() => window.open(currentBanner?.link, "_blank")}
                          style={{ position: "relative", minHeight: "215px" }}
                        >
                          {/* Background — banner image bersih, cover penuh */}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundImage: `url(${currentBanner?.image_url})`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                            }}
                          />
                          {/* Frosted glass overlay di atas background */}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backdropFilter: "blur(15px)",
                              WebkitBackdropFilter: "blur(15px)",
                              backgroundColor: "rgba(0, 0, 0, 0.15)",
                            }}
                          />
                          {/* Foreground — banner image bersih, centered dengan contain */}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              alt="banner"
                              src={currentBanner?.image_url}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
              <Col md="12">
                {/*{!dataPrev?.isTimeBid ? (*/}
                <div className="pagination">
                  {/* <div>Halaman:</div>
                                            <div><span className='fw-bold'>{pageNumber}</span> dari <span>{paginate.total}</span></div>
                                            <div>
                                                <ul>
                                                    <li>
                                                        <div className='cursor-pointer' onClick={prevPage}>
                                                            <span className="previous">
                                                                <Previous fill={"#FFFFFF"} />
                                                            </span>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className='cursor-pointer' onClick={nextPage}>
                                                            <span className="next">
                                                                <Next fill={"#FFFFFF"} />
                                                            </span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div> */}

                  {paginate.total > 1 && (
                    <>
                      <Col>Halaman :</Col>
                      <Col className="rowPagination">
                        <Form onSubmit={handleSubmit(onSubmit)} style={{}}>
                          <Form.Group className="form-group" controlId="formBasicEmail">
                            {/* <label htmlFor="pageInput"></label> */}
                            <Controller
                              control={control}
                              name="page"
                              render={({ field: { onChange, name, value } }) => (
                                <input
                                  style={{ width: 50 }}
                                  type="text"
                                  className="form-control "
                                  id="pageInput"
                                  name={name}
                                  value={value || ""}
                                  onChange={(e) => {
                                    if (/^\d*$/.test(e.target.value) && e.target.value !== "0") {
                                      onChange(e.target.value);
                                      setJumptoPage(e.target.value);
                                    }
                                  }}
                                  // onChange={(e) =>
                                  //   setJumptoPage(e.target.value)
                                  // }
                                />
                              )}
                            />
                          </Form.Group>
                        </Form>
                      </Col>

                      <Col className="rowPagination ">dari {paginate.total}</Col>

                      <ReactPaginate
                        // breakLabel="..."
                        nextLabel={">"}
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={2}
                        pageCount={paginate.total}
                        previousLabel="<"
                        renderOnZeroPageCount={null}
                        forcePage={pageSelected}
                        disabledClassName="paginationUnitDisabled"
                        containerClassName="pagination-container-unit mt-3"
                        activeClassName="active"
                        pageClassName="paginationNone"
                        breakClassName="paginationNone"
                        nextClassName="paginationUnit-item next"
                        previousClassName="paginationUnit-item previous"
                      />
                    </>
                  )}
                </div>
                {/*) : (*/}
                <></>
                {/*)}*/}
              </Col>
              <Modal
                show={showRisalah}
                onHide={() => setShowRisalah(false)}
                dialogClassName="modal-width-90"
                size="lg"
                aria-labelledby="risalah"
              >
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">Risalah</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div style={{ height: "87vh", display: "flex", flexDirection: "column" }}>
                    <iframe
                      src={`https://docs.google.com/gview?url=${encodeURIComponent(
                        data[0]?.auction?.risalah_file_url || ""
                      )}&embedded=true`}
                      title="Risalah PDF"
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      style={{ flex: 1, border: "none" }}
                    />
                    <div style={{ padding: "8px", textAlign: "center", fontSize: "13px", color: "#666" }}>
                      Jika PDF tidak terlihat,{" "}
                      <a
                        href={data[0]?.auction?.risalah_file_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#d32f2f", textDecoration: "underline" }}
                      >
                        buka di tab baru
                      </a>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </>
          ) : (
            <div className="text-center text-secondary mt-5">Unit lelang tidak ditemukan</div>
          )}
        </InfiniteScroll>
      </Container>
    </div>
  );
}
